var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageToPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 161,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9213_2101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.833 5.32308C142.132 3.94268 161.518 -3.41956 179.807 1.91346C199.063 7.52856 213.456 21.0381 224.973 35.1068C237.051 49.86 251.263 66.8263 247.333 84.3986C243.373 102.109 252.849 117.68 238.895 131.412C227.707 142.423 188.655 150.848 173.216 157.341C157.945 163.763 139.845 160.065 122.833 158.673C107.206 157.395 92.2834 154.685 77.8404 149.537C61.8904 143.852 46.5478 137.385 34.3056 127.121C19.5871 114.781 -1.99131 101.732 0.147587 84.3986C2.34911 66.5579 30.9027 60.5172 44.2568 46.4786C55.1526 35.0243 56.3879 17.4502 71.2232 9.67995C86.1291 1.87278 105.306 6.57666 122.833 5.32308Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 119.52V42.4796C32.5 40.2689 34.2394 38.5 36.3571 38.5H81.3093L99.4997 57.2015V119.52C99.4997 121.731 97.7603 123.5 95.6426 123.5H36.3571C34.2402 123.5 32.5 121.732 32.5 119.52Z",
    fill: "white",
    stroke: "#5F30E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 60,
    width: 48,
    height: 28,
    rx: 2,
    fill: "#FCEDF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M49 73.5089L52.1781 70.6773C53.8316 69.2042 56.3235 69.2887 57.8771 70.8706L65.6605 78.7958C66.9074 80.0655 68.8702 80.2386 70.313 79.2062L70.8541 78.819C72.9302 77.3333 75.7391 77.5055 77.6253 79.2339L83.4741 84.5939",
    stroke: "#5F30E2",
    strokeWidth: 2.48001,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 79.5327,
    cy: 68.7614,
    rx: 4,
    ry: 4.12469,
    stroke: "#5F30E2",
    strokeWidth: 2.48001
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 94,
    width: 52,
    height: 22,
    rx: 2.68571,
    fill: "#5F30E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3168 109V100.54H49.1768V109H47.3168ZM50.8916 109V100.54H52.4396L55.4996 106.108H55.0916L58.1396 100.54H59.6636V109H57.9716V103.384H58.2356L55.7876 107.728H54.7436L52.2836 103.372H52.5716V109H50.8916ZM60.4073 109L64.2953 100.54H65.7953L69.6833 109H67.8113L66.8033 106.648L67.5473 107.164H62.5433L63.2873 106.648L62.2913 109H60.4073ZM65.0273 102.52L63.4913 106.18L63.1673 105.712H66.9233L66.5993 106.18L65.0513 102.52H65.0273ZM74.4033 109.132C73.4513 109.132 72.6433 108.952 71.9793 108.592C71.3233 108.232 70.8233 107.728 70.4793 107.08C70.1353 106.432 69.9633 105.672 69.9633 104.8C69.9633 103.904 70.1393 103.128 70.4913 102.472C70.8513 101.816 71.3673 101.308 72.0393 100.948C72.7193 100.588 73.5273 100.408 74.4633 100.408C74.8633 100.408 75.2473 100.448 75.6153 100.528C75.9833 100.6 76.3233 100.704 76.6353 100.84C76.9553 100.976 77.2273 101.14 77.4513 101.332L76.8513 102.784C76.4833 102.512 76.1073 102.32 75.7233 102.208C75.3393 102.088 74.9233 102.028 74.4753 102.028C73.6193 102.028 72.9753 102.264 72.5433 102.736C72.1193 103.208 71.9073 103.896 71.9073 104.8C71.9073 105.704 72.1233 106.388 72.5553 106.852C72.9953 107.316 73.6433 107.548 74.4993 107.548C74.7873 107.548 75.0833 107.52 75.3873 107.464C75.6913 107.408 75.9913 107.328 76.2873 107.224L75.9393 107.98V105.676H74.1153V104.332H77.4753V108.484C77.2033 108.62 76.8953 108.736 76.5513 108.832C76.2153 108.928 75.8633 109 75.4953 109.048C75.1273 109.104 74.7633 109.132 74.4033 109.132ZM79.1215 109V100.54H84.9175V101.992H80.8975V103.972H84.6535V105.436H80.8975V107.548H84.9175V109H79.1215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1924 52.5996V39.2353L98.8201 56.411H85.8662C83.8527 56.411 82.1924 54.7205 82.1924 52.5996Z",
    fill: "white",
    stroke: "#5F30E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.692 70.7745L133.538 76.0574C135.846 78.1436 137 79.1867 137 80.5305C137 81.8742 135.846 82.9173 133.538 85.0035L127.692 90.2865C126.639 91.2387 126.112 91.7149 125.678 91.5166C125.243 91.3182 125.243 90.6016 125.243 89.1682V85.6603C119.946 85.6603 114.207 88.2252 112 92.5C112 78.8205 119.848 75.4007 125.243 75.4007V71.8927C125.243 70.4594 125.243 69.7427 125.678 69.5444C126.112 69.3461 126.639 69.8222 127.692 70.7745Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 119.52V42.4796C149.5 40.2686 151.238 38.5 153.354 38.5H198.271L216.448 57.2014V119.52C216.448 121.731 214.709 123.5 212.594 123.5H153.354C151.239 123.5 149.5 121.732 149.5 119.52Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.494,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.494,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.888 110.476V101.524H174.954C175.947 101.524 176.713 101.778 177.251 102.286C177.79 102.785 178.06 103.484 178.06 104.381C178.06 105.278 177.79 105.981 177.251 106.489C176.713 106.997 175.947 107.251 174.954 107.251H172.845V110.476H170.888ZM172.845 105.727H174.625C175.661 105.727 176.178 105.278 176.178 104.381C176.178 103.501 175.661 103.06 174.625 103.06H172.845V105.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.272 110.476V101.524H182.757C184.272 101.524 185.446 101.913 186.28 102.692C187.113 103.463 187.53 104.563 187.53 105.994C187.53 107.424 187.113 108.529 186.28 109.308C185.446 110.087 184.272 110.476 182.757 110.476H179.272ZM181.229 108.864H182.643C184.537 108.864 185.484 107.907 185.484 105.994C185.484 104.089 184.537 103.137 182.643 103.137H181.229V108.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.05 110.476V101.524H195.06V103.06H191.007V105.245H194.782V106.781H191.007V110.476H189.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.207 52.5996V39.236L215.821 56.411H202.877C200.866 56.411 199.207 54.7209 199.207 52.5996Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 63.5H201C201.828 63.5 202.5 64.1716 202.5 65V66C202.5 66.8284 201.828 67.5 201 67.5H165C164.172 67.5 163.5 66.8284 163.5 66V65C163.5 64.1716 164.172 63.5 165 63.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 73.5H201C201.828 73.5 202.5 74.1716 202.5 75V76C202.5 76.8284 201.828 77.5 201 77.5H165C164.172 77.5 163.5 76.8284 163.5 76V75C163.5 74.1716 164.172 73.5 165 73.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 83.5H201C201.828 83.5 202.5 84.1716 202.5 85V86C202.5 86.8284 201.828 87.5 201 87.5H165C164.172 87.5 163.5 86.8284 163.5 86V85C163.5 84.1716 164.172 83.5 165 83.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9213_2101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 161,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageToPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image_to_pdf.dc747773223b2166fe8a752c1933022e.svg";